module.exports = __webpack_public_path__ + "8d13128abc21b0b89cb9c3f029b00899.png";